import { required, email, digits, integer, min_value, max_value, confirmed, is, double, min, max } from 'vee-validate/dist/rules'
import { localize, extend } from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr.json'
import en from 'vee-validate/dist/locale/en.json'
import messages from './assets/langs/langs'

// Install rules
extend("required", required)
extend("email", email)
extend("digits", digits)
extend("integer", integer)
extend("min_value", min_value)
extend("max_value", max_value)
extend("confirmed", confirmed)
extend("decimal:2", double)
extend("min", min)
extend("max", max)
extend("is", is)
extend('phone', {
  validate(value) {
    return value.match(/^(\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14})|(00\d{1,14})$/)
  }
})
extend('is_valid_json',{
    validate(value) {
        try {
            JSON.parse(value);
            return true;
        } catch (error) {
            return false;
        }
    }
})

// Install English and French localizations.
localize({
  en: {
    messages: {
      ...en.messages,
      phone: field => `The ${field} field must be a phone number. Format: +123456789`,
      is: field => `The ${field} field is not equal`,
      is_valid_json: field => `The JSON is not correctly formatted`
    }
  },
  fr: {
    messages: {
      ...fr.messages,
      phone: field => `Le champ ${field} doit être un numéro de téléphone. Format : +123456789`,
      is: field => `Le champ ${field} ne correspond pas`,
      is_valid_json: field => `Le JSON n'est pas bien formé`
    }
  }
})

type Rules = 'required' | 'email' | 'digits' | 'phone' | 'integer' | 'min_value' | 'max_value' | 'confirmed' | 'is' | 'is_valid_json' | 'decimal:2' | 'min' | 'max'

export type RuleObject = 
{
  [key in Exclude<Rules, 'min_value' | 'max_value'>]?: any
} 
| {
  min_value: string
}
| {
  max_value: string
}

export type Validable<T> = T & {
  rules?: RuleObject
}